/* export
  - menuIdRouteMappings
  - menuIdNameMappingsFromBundle
*/

export * from 'sce-core';
// #TODO-LIBRARY constants->menuIdRouteMappings Used in 13 places 13 files in WMS /src/app.. should be re-referenced from library directly
